import React from "react";
import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";
import { COMPANY } from "@/data/site";

export default function Accessibility() {
  return (
    <LegalLayout title="Accessibility" updated="June 2026">
      <P>
        {COMPANY.name} is committed to making this website accessible to as many people as possible, regardless of
        ability or technology.
      </P>

      <H2>Our commitment</H2>
      <UL
        items={[
          "We aim to follow recognised accessibility guidelines (WCAG 2.1 AA) as closely as is practical.",
          "We use clear, structured headings and readable text with strong colour contrast.",
          "The site is designed to work on mobile, tablet and desktop devices.",
          "We respect reduced-motion preferences and limit non-essential motion for users who request it.",
          "Interactive elements are keyboard accessible and labelled for assistive technologies where possible.",
        ]}
      />

      <H2>Feedback</H2>
      <P>
        We are always working to improve. If you experience any difficulty using this website, or need information in a
        different format, please contact us at{" "}
        <a className="underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> and we will do our best to help.
      </P>
    </LegalLayout>
  );
}
